import Link from 'next/link';
import { themeConfig } from '../../theme';
import { ROUTES } from '../../constants/routes';

/** Marketing footer with nav links — used on guest auth routes only; public marketing uses {@link PublicPoweredByFooter}. */
export function MainFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className='mt-auto border-t border-accent-foreground/15 bg-accent text-accent-foreground'>
      <div className='mx-auto max-w-6xl px-4 py-10 sm:px-6 lg:px-8'>
        <div className='flex flex-col gap-8 sm:flex-row sm:items-start sm:justify-between'>
          <div className='flex max-w-sm flex-col gap-3'>
            <img
              src={themeConfig.logos.wordmark}
              alt={themeConfig.brand.legalName}
              className='h-8 w-auto max-w-[220px] object-left object-contain'
            />
            <p className='text-sm text-accent-foreground/80'>
              Connecting shelters and adopters with a consistent, branded
              experience you can tailor to your organization.
            </p>
          </div>
          <div className='flex flex-col gap-2 text-sm'>
            <span className='font-medium text-accent-foreground'>Navigate</span>
            <Link
              href={ROUTES.matchingPoc}
              className='text-accent-foreground/80 hover:text-primary-600'
            >
              Matching quiz
            </Link>
          </div>
        </div>
        <p className='mt-10 border-t border-accent-foreground/15 pt-6 text-center text-xs text-accent-foreground/70 sm:text-left'>
          © {year} {themeConfig.brand.legalName}. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
